<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营数据</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>外部支付登记</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-form :inline="true" :model="query" size="small" class="search-form">
        <el-form-item label="业务编码">
          <el-input v-model="query.businessCode" clearable placeholder="请输入业务编码"></el-input>
        </el-form-item>
        <el-form-item label="医院">
          <el-input v-model="query.hospitalName" clearable placeholder="请输入医院"></el-input>
        </el-form-item>
        <el-form-item label="科室">
          <el-input v-model="query.departmentName" clearable placeholder="请输入科室"></el-input>
        </el-form-item>
        <el-form-item label="医生">
          <el-input v-model="query.doctorKeyword" clearable placeholder="姓名/手机号"></el-input>
        </el-form-item>
        <el-form-item label="患者">
          <el-input v-model="query.patientKeyword" clearable placeholder="姓名/手机号"></el-input>
        </el-form-item>
        <el-form-item label="登记时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button plain @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loading="loading"
        :data="records"
        style="width: 100%"
        stripe
        border
      >
        <el-table-column prop="bindOrderNo" label="登记单号" min-width="160"></el-table-column>
        <el-table-column label="业务" min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.businessName }}</div>
            <div class="muted">{{ scope.row.businessCode }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="hospitalName" label="医院" min-width="180"></el-table-column>
        <el-table-column prop="departmentName" label="科室" min-width="120"></el-table-column>
        <el-table-column label="医生" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.doctorName }}</div>
            <div class="muted">{{ scope.row.doctorPhone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="患者" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.patientName }}</div>
            <div class="muted">{{ scope.row.patientMobile }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" min-width="170">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        :current-page="query.page"
        :page-size="query.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ExternalPaidOrderBindList',
  data () {
    return {
      loading: false,
      records: [],
      total: 0,
      dateRange: [],
      query: {
        businessCode: '',
        hospitalName: '',
        departmentName: '',
        doctorKeyword: '',
        patientKeyword: '',
        page: 1,
        pageSize: 10
      }
    }
  },
  created () {
    this.loadRecords()
  },
  methods: {
    async loadRecords () {
      this.loading = true
      const params = Object.assign({}, this.query)
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = new Date(this.dateRange[0]).getTime()
        const end = new Date(this.dateRange[1])
        end.setHours(23, 59, 59, 999)
        params.endTime = end.getTime()
      }
      const { data: resp } = await this.$http.get('external_paid_order/page', { params })
      this.loading = false
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.records = resp.data.content || []
      this.total = resp.data.totalElements || 0
    },
    search () {
      this.query.page = 1
      this.loadRecords()
    },
    reset () {
      this.dateRange = []
      this.query = {
        businessCode: '',
        hospitalName: '',
        departmentName: '',
        doctorKeyword: '',
        patientKeyword: '',
        page: 1,
        pageSize: 10
      }
      this.loadRecords()
    },
    handleCurrentChange (val) {
      this.query.page = val
      this.loadRecords()
    },
    formatTime (value) {
      if (!value) return ''
      return new Date(value).toLocaleString()
    }
  }
}
</script>

<style lang="less" scoped>
.search-form {
  margin-bottom: 12px;
}

.muted {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
